import { Star } from "lucide-react"
import { motion } from "framer-motion"

const testimonials = [
  {
    quote: "FlexHelp has transformed how we handle maintenance. The platform is intuitive, and the service providers are top-notch. Highly recommended!",
    author: "Sarah Johnson",
    role: "Property Manager",
    company: "Urban Living Properties"
  },
  {
    quote: "Since implementing FlexHelp, we've reduced our maintenance response time by 60%. The automated scheduling is a game-changer.",
    author: "Michael Chen",
    role: "Facility Director",
    company: "Premier Properties"
  },
  {
    quote: "The quality of service providers and the ease of use make FlexHelp an essential tool for our property management operations.",
    author: "Emily Rodriguez",
    role: "Operations Manager",
    company: "Skyline Residences"
  }
]

export function Testimonials() {
  return (
    <section className="border-t bg-muted/50">
      <div className="container py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mx-auto text-center md:max-w-[58rem]"
        >
          <h2 className="font-heading text-3xl font-bold leading-[1.1] sm:text-4xl md:text-5xl">
            Trusted by property managers
          </h2>
          <p className="mt-4 text-muted-foreground sm:text-lg">
            Here's what our customers have to say about FlexHelp
          </p>
        </motion.div>

        <div className="mx-auto mt-16 grid gap-8 sm:grid-cols-2 md:max-w-[64rem] lg:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative rounded-lg border bg-background p-8"
            >
              <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
              <div className="relative">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-primary text-primary" />
                  ))}
                </div>
                <blockquote className="mt-4">
                  <p className="text-muted-foreground">
                    "{testimonial.quote}"
                  </p>
                </blockquote>
                <div className="mt-6 flex items-center gap-3">
                  <div className="rounded-full bg-primary/10 p-1">
                    <div className="h-8 w-8 rounded-full bg-primary/20" />
                  </div>
                  <div>
                    <div className="font-semibold">{testimonial.author}</div>
                    <div className="text-sm text-muted-foreground">
                      {testimonial.role} · {testimonial.company}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}